// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1puTU","cell":"ColumnAccessor_cell__QQb2r","firstCellAccent":"ColumnAccessor_firstCellAccent__1lbCS"};